import React from 'react';
import PropTypes from 'prop-types';
import {AuthContext} from '../../lib/auth/auth-context.jsx';
import AuthModal from './auth-modal.jsx';
import {apiUrl} from '../../lib/api-base.js';
import {navigateTo} from '../../lib/nav.js';
import styles from './auth-button.css';

class AuthButton extends React.Component {
    constructor (props) {
        super(props);
        this.state = {
            dropdownOpen: false,
            showAuthModal: false
        };
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.closeDropdown = this.closeDropdown.bind(this);
        this.handleMyProjects = this.handleMyProjects.bind(this);
        this.handleLogout = this.handleLogout.bind(this);
        this.openAuthModal = this.openAuthModal.bind(this);
        this.closeAuthModal = this.closeAuthModal.bind(this);
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    componentDidMount () {
        document.addEventListener('mousedown', this.handleClickOutside);
    }
    componentWillUnmount () {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }
    handleClickOutside (event) {
        if (this.wrapperRef.current && !this.wrapperRef.current.contains(event.target)) {
            this.closeDropdown();
        }
    }
    toggleDropdown () {
        this.setState(prev => ({dropdownOpen: !prev.dropdownOpen}));
    }
    closeDropdown () {
        this.setState({dropdownOpen: false});
    }
    openAuthModal () {
        this.setState({showAuthModal: true});
    }
    closeAuthModal () {
        this.setState({showAuthModal: false});
    }
    handleMyProjects () {
        this.closeDropdown();
        navigateTo('/my-projects');
    }
    handleLogout () {
        this.closeDropdown();
        fetch(apiUrl('/api/auth/logout'), {method: 'POST', credentials: 'include'})
            .then(() => {
                window.location.reload();
            })
            .catch(() => {
                window.location.reload();
            });
    }
    render () {
        return (
            <AuthContext.Consumer>
                {({user, isLoading, isAuthenticated, refresh}) => {
                    if (isLoading) return null;

                    if (!isAuthenticated) {
                        return (
                            <div className={styles.authButtonWrapper}>
                                <button
                                    className={styles.signInButton}
                                    onClick={this.openAuthModal}
                                >
                                    Sign In
                                </button>
                                {this.state.showAuthModal && (
                                    <AuthModal
                                        onClose={this.closeAuthModal}
                                        onSuccess={refresh}
                                    />
                                )}
                            </div>
                        );
                    }

                    const displayName = user.first_name ||
                        user.username ||
                        user.email ||
                        'User';
                    const initial = displayName.charAt(0).toUpperCase();

                    return (
                        <div className={styles.userSection} ref={this.wrapperRef}>
                            <span
                                className={styles.userName}
                                onClick={this.toggleDropdown}
                            >
                                {displayName}
                            </span>
                            {user.profile_image_url ? (
                                <img
                                    className={styles.userAvatar}
                                    src={user.profile_image_url}
                                    alt={displayName}
                                    onClick={this.toggleDropdown}
                                    draggable={false}
                                />
                            ) : (
                                <div
                                    className={styles.userAvatarPlaceholder}
                                    onClick={this.toggleDropdown}
                                >
                                    {initial}
                                </div>
                            )}
                            {this.state.dropdownOpen && (
                                <div className={styles.userDropdown}>
                                    <button
                                        className={styles.dropdownItem}
                                        onClick={this.handleMyProjects}
                                    >
                                        My Projects
                                    </button>
                                    <div className={styles.dropdownDivider} />
                                    <button
                                        className={`${styles.dropdownItem} ${styles.danger}`}
                                        onClick={this.handleLogout}
                                    >
                                        Sign Out
                                    </button>
                                </div>
                            )}
                        </div>
                    );
                }}
            </AuthContext.Consumer>
        );
    }
}

AuthButton.propTypes = {
    onOpenMyProjects: PropTypes.func
};

export default AuthButton;
